/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vpn_Feature_2Inputs */

const en_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protect up to 10 devices`)
};

const id_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melindungi hingga 10 perangkat`)
};

const ms_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lindungi sehingga 10 peranti`)
};

const ca_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protegeix fins a 10 dispositius`)
};

const cs_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ochrana až 10 zařízení`)
};

const da_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beskyt op til 10 enheder`)
};

const de_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schütze bis zu 10 Geräte`)
};

const et_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaitseb kuni 10 seadet`)
};

const es_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protege hasta 10 dispositivos`)
};

const fr_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protégez jusqu’à 10 appareils`)
};

const hr_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaštitite do 10 uređaja`)
};

const it_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proteggi fino a 10 dispositivi`)
};

const lv_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aizsargā līdz pat 10 ierīcēm`)
};

const lt_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apsaugo iki 10 įrenginių`)
};

const hu_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akár 10 eszköz védelme`)
};

const nl_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bescherming voor max. 10 apparaten`)
};

const nb_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beskytt opptil 10 enheter`)
};

const pl_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ochrona do 10 urządzeń`)
};

const pt_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proteja até 10 dispositivos`)
};

const ro_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protejează până la 10 dispozitive`)
};

const sk_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ochrana až 10 zariadení`)
};

const sl_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaščitite do 10 naprav`)
};

const fi_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suojaa jopa 10 laitetta`)
};

const sv_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skydda upp till tio enheter`)
};

const vi_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bảo vệ lên đến 10 thiết bị`)
};

const tr_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 cihaza kadar koruma`)
};

const el_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Προστασία έως και 10 συσκευών`)
};

const bg_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Защита на до 10 устройства`)
};

const ru_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Защитите до 10 устройств`)
};

const sr_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заштитите до 10 уређаја`)
};

const uk_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Захистіть до 10 пристроїв`)
};

const ka_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`დაიცავით 10-მდე მოწყობილობა`)
};

const hi_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`१० डिवाइसेस तक को सुरक्षित रखें `)
};

const th_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปกป้องอุปกรณ์ได้สูงสุด 10 เครื่อง`)
};

const ko_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최대 10대의 기기 보호`)
};

const zh_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可最多保护 10 台设备`)
};

const zh_tw_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最多可保護 10 部裝置`)
};

const ja_vpn_feature_2 = /** @type {(inputs: Vpn_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大10台のデバイスを保護`)
};

/**
* | output |
* | --- |
* | "Protect up to 10 devices" |
*
* @param {Vpn_Feature_2Inputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const vpn_feature_2 = /** @type {((inputs?: Vpn_Feature_2Inputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vpn_Feature_2Inputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_vpn_feature_2(inputs)
	if (locale === "ms") return ms_vpn_feature_2(inputs)
	if (locale === "ca") return ca_vpn_feature_2(inputs)
	if (locale === "cs") return cs_vpn_feature_2(inputs)
	if (locale === "da") return da_vpn_feature_2(inputs)
	if (locale === "de") return de_vpn_feature_2(inputs)
	if (locale === "et") return et_vpn_feature_2(inputs)
	if (locale === "es") return es_vpn_feature_2(inputs)
	if (locale === "fr") return fr_vpn_feature_2(inputs)
	if (locale === "hr") return hr_vpn_feature_2(inputs)
	if (locale === "it") return it_vpn_feature_2(inputs)
	if (locale === "lv") return lv_vpn_feature_2(inputs)
	if (locale === "lt") return lt_vpn_feature_2(inputs)
	if (locale === "hu") return hu_vpn_feature_2(inputs)
	if (locale === "nl") return nl_vpn_feature_2(inputs)
	if (locale === "nb") return nb_vpn_feature_2(inputs)
	if (locale === "pl") return pl_vpn_feature_2(inputs)
	if (locale === "pt") return pt_vpn_feature_2(inputs)
	if (locale === "ro") return ro_vpn_feature_2(inputs)
	if (locale === "sk") return sk_vpn_feature_2(inputs)
	if (locale === "sl") return sl_vpn_feature_2(inputs)
	if (locale === "fi") return fi_vpn_feature_2(inputs)
	if (locale === "sv") return sv_vpn_feature_2(inputs)
	if (locale === "vi") return vi_vpn_feature_2(inputs)
	if (locale === "tr") return tr_vpn_feature_2(inputs)
	if (locale === "el") return el_vpn_feature_2(inputs)
	if (locale === "bg") return bg_vpn_feature_2(inputs)
	if (locale === "ru") return ru_vpn_feature_2(inputs)
	if (locale === "sr") return sr_vpn_feature_2(inputs)
	if (locale === "uk") return uk_vpn_feature_2(inputs)
	if (locale === "ka") return ka_vpn_feature_2(inputs)
	if (locale === "hi") return hi_vpn_feature_2(inputs)
	if (locale === "th") return th_vpn_feature_2(inputs)
	if (locale === "ko") return ko_vpn_feature_2(inputs)
	if (locale === "zh") return zh_vpn_feature_2(inputs)
	if (locale === "zh-tw") return zh_tw_vpn_feature_2(inputs)
	if (locale === "ja") return ja_vpn_feature_2(inputs)
	return en_vpn_feature_2(inputs)
});